<template>
  <v-navigation-drawer
    app
    clipped
    absolute
    :expand-on-hover="expandOnHover"
    :mini-variant="miniVariant"
    :permanent="permanent"
    width="200"
  >
    <v-list nav dense>
      <account></account>
      <v-divider></v-divider>
      <v-list-item-group>
        <v-list-item
          v-for="item in items"
          :to="item.to"
          v-bind:key="item.to"
          color="primary"
        >
          <v-list-item-icon>
            <v-icon color="primary">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title color="primary">{{
            item.title
          }}</v-list-item-title>
        </v-list-item>
      </v-list-item-group>
      <v-divider></v-divider>
      <v-list-item color="secondary" @click="onToggleTheme">
        <v-list-item-icon>
          <v-icon>mdi-theme-light-dark</v-icon>
        </v-list-item-icon>
        <v-list-item-title>
          {{ theme }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import account from '@/components/Account.vue'
import store from "@/store/index.js";

export default {
  name: 'appnavigation',

  components: {
    account,
  },

  data: () => ({
    expandOnHover: true,
    miniVariant: false,
    permanent: true,
    items: [
      {
        to: '/news',
        icon: 'mdi-newspaper',
        title: 'News',
      },
      {
        to: '/schedule',
        icon: 'mdi-calendar-text',
        title: 'Schedule',
      },
      {
        to: '/calendar',
        icon: 'mdi-calendar-month',
        title: 'Calendar',
      },
      {
        to: '/results',
        icon: 'mdi-clipboard-list-outline',
        title: 'Results',
      },
      {
        to: '/money',
        icon: 'mdi-currency-usd',
        title: 'Money List',
      },
      {
        to: '/association',
        icon: 'mdi-account-group',
        title: 'Association',
      },
      {
        to: '/faq',
        icon: 'mdi-help-circle-outline',
        title: 'FAQ',
      },
      {
        to: '/links',
        icon: 'mdi-link',
        title: 'Links',
      },
      {
        to: '/about',
        icon: 'mdi-help-circle',
        title: 'About',
      },
    ],
    theme: "Light Theme"
  }),

  methods: {
    getName() {
      var name = 'Login'
      if (this.$store.getters.getLoggedIn) {
        name = this.$store.getters.getName
      }
      return name
    },
    getRole() {
      var role = ''
      if (this.$store.getters.getLoggedIn) {
        if (this.$store.getters.getAdministrator) {
          role = 'Administrator'
        } else if (this.$store.getters.getProShop) {
          role = 'Pro Shop'
        }
      }

      return role
    },
    isLoggedIn() {
      return this.$store.getters.getLoggedIn
    },

    onToggleTheme() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
      store.commit('setDark', this.$vuetify.theme.dark)
      this.theme = this.$vuetify.theme.dark ? 'Light Theme' : 'Dark Theme'
    },
  },
}
</script>
